import React, { useEffect, useState } from "react";
import { useStoreState, useStoreActions } from "easy-peasy";
import Modal from "react-bootstrap/Modal";
import { useHistory } from "react-router-dom";
import AxiosWrapper from "../../../../services/axios";
import SubmitApplicationService from "../../../../services/submitApplication";
import AudioEyeSupport from "../../../../services/audioEyeSupport";

function MfaEmail() {
    const SubmitApp = SubmitApplicationService()
    const setApplicationResult = useStoreActions(actions => actions.applicationResultModel.setApplicationResult);
    const ada = new AudioEyeSupport();
    const info = useStoreState(state => state.applicantModel.applicant);
    const mfaemail = useStoreState((state) => state.mfaemail);
    const history = useHistory();
    const [code, setCode] = useState('')
    const [reSendCode, setReSendCode] = useState("Didn't get a verification code?")
    const [showError, setShowError] = useState(false)
    const setdisplayResult = useStoreActions((actions) => actions.setDisplayResult);
    const client = new AxiosWrapper()
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        if(mfaemail === true){
            sendSmsCode('Email')
            handleInputBlock('block2');
        }
       // eslint-disable-next-line react-hooks/exhaustive-deps
    },[mfaemail])

    function handleInputBlock(blockId) {
        let inputs = document.querySelectorAll(`#${blockId} .mfaInputs`);
    
        inputs.forEach((input, index, array2) => {
            // Handle input event
            input.addEventListener('input', () => {
                // Allow only numeric characters
                if (!/^\d$/.test(input.value)) {
                    input.value = ''; // Clear input if it's not a number
                    return;
                }
                // Move to the next input if this one is filled
                if (input.value.length === 1 && index < array2.length - 1) {
                    array2[index + 1].focus();
                }
            });
    
            // Handle backspace event
            input.addEventListener('keydown', (e) => {
                if (e.key === 'Backspace') {
                    if (input.value === '') {
                        // Move to the previous input if current is empty
                        if (index > 0) {
                            array2[index - 1].value = ''; // Clear the previous input
                            array2[index - 1].focus();
                        }
                    } else {
                        // Clear current input if not empty
                        input.value = '';
                    }
                    e.preventDefault(); // Prevent default backspace behavior
                }
            });
    
            // Focus on first empty input when an input is focused
            input.addEventListener('focus', () => {
                const firstEmptyIndex = [...array2].findIndex(input => input.value === '');
                if (firstEmptyIndex !== -1 && firstEmptyIndex !== index) {
                    array2[firstEmptyIndex].focus();
                }
            });
        });
    
        // Initially set focus to the first empty input
        const firstEmptyIndex = [...inputs].findIndex(input => input.value === '');
        if (firstEmptyIndex !== -1) {
            inputs[firstEmptyIndex].focus();
        }
    }



    function getEmailMasked(){

        return info.Email.slice(0, 2) + '***@' +  (info.Email.split('@')[1] || '');
    }

    function reSendSms(){
        if(reSendCode === "Didn't get a verification code?"){
            sendSmsCode('Email')
            setReSendCode("Verification code sent")
        }
        
    }

    async function sendSmsCode(type){
    
        let result = await client.post('/send-Mfa', {contactIdentifier : info.Email, contactType : type}, true)
        if(result && result.Success === true){
            sessionStorage.setItem('sessionToken', result.Payload)
            return
        }
        setShowError('An Error as ocurred please try again later')
    }

    function takeDigit(e){
        setShowError(false)
        if(e.nativeEvent.key === "Backspace"){
            setCode(code.slice(0, -1))
        }else{
            if(/[0-9]/.test(e.nativeEvent.key) && e.nativeEvent.key.length === 1){
                if(code.length < 6){
                    setCode(code + e.nativeEvent.key)
                }
            }
        }
    }

    async function Submit(){
        setLoading(true)
        let result = await client.post('/verify-Mfa', {verifyCode : code}, true);
    
        if(result && result.Success === true){
            sessionStorage.setItem('sessionToken', result.Payload)
            await SubmitApplication()
            return
        }
        if(result && result.Success === false){
            if(result.StatusCode === 401){
                setLoading(false)
                setShowError('The verification code you entered is invalid, or your code as expired')
                return
            }
        }
        setLoading(false)
        setShowError('An Error as ocurred please try again later')
    }

    async function SubmitApplication(){
        
        try{
           
    
            let result = await SubmitApp.submitApplicationOffer(info);
            setApplicationResult(result);
            window.scrollTo(0, 0);
            if(result){
                setdisplayResult(true)
                if(result.decision === "APPROVED"){
                ada.sendDYEvent({name : 'prequal_accept'});
                setApplicationResult({ result: "APPROVED" });
                history.push(`/approved`+window.location.search);
                return true;
                }
                history.push(`/declined`+window.location.search);
                return true;
            }
            setShowError('An Error as ocurred please try again later')
            return false;
        }catch(Error){
            console.log(Error);
            setShowError('An Error as ocurred please try again later')
        }
     
}

    return (
        <>
        <Modal show={mfaemail} backdrop="static" id="mfa-modal" onHide={() => true} centered >
            <Modal.Header>
            <Modal.Title className="justify-content-center align-items-center MfaTitle " >We've sent your verification code.</Modal.Title>
            </Modal.Header>
            <Modal.Body className="font18">
                <div className="row">
                    <div className="col-12">
                        <p className="mb-1">A 6-digit verification code was sent to <strong>{ getEmailMasked() }</strong> </p>
                        <p>Please allow up to 1 minute to receive it.</p>
                        <p className="mb-0"><strong>Enter verification code</strong></p>
                    </div>
                    <div className="col-12">
                        {
                            (showError !== false) && (
                                <p style={{fontSize : '1.2em'}} className="mb-0 mt-3 text-center error-message"><strong>{ showError }</strong></p>
                            )
                        } 
                    </div>
                    <div className="col-12">
                        <div className="input-container-modal" id="block2">
                            <input onKeyDown={(e) => { takeDigit(e) }} type="text" class=" mfaInputs" maxlength="1" />
                            <input onKeyDown={(e) => { takeDigit(e) }} type="text" class=" mfaInputs" maxlength="1" />
                            <input onKeyDown={(e) => { takeDigit(e) }} type="text" class=" mfaInputs" maxlength="1"  />
                            <input onKeyDown={(e) => { takeDigit(e) }} type="text" class=" mfaInputs" maxlength="1"/>
                            <input onKeyDown={(e) => { takeDigit(e) }} type="text" class=" mfaInputs" maxlength="1" />
                            <input onKeyDown={(e) => { takeDigit(e) }} type="text" class=" mfaInputs" maxlength="1"  />
                        </div>
                   </div>
                   
                    
                </div>
                <div className="row">
                    <div className="col-12 text-center">
                        <button onClick={() => Submit()} disabled={code.length < 6 || loading} style={{marginTop : 'none !important'}} className="btn text-small mt-3 MfaEmailButton mfabutton mt-0 btn-info"> 
                         {!loading ? 'Submit' : 'Loading...'} 
                        </button>
                    </div>
                </div>
                <div className="row mt-4 mb-1 MfaSmallerText">
                    <div className="col-12 text-center">
                        <p className="mb-1"><span className="fakeLink" onClick={() => reSendSms()} >{reSendCode}</span></p>
                    </div>
                </div>
                <div className="row MfaSmallerText">
                    <div className="col-12 text-center">
                        <p>Standard message & data rates may apply</p>
                    </div>
                </div>
            </Modal.Body>
          
        </Modal>
        </>
    );
}

export default MfaEmail;
